import { PrizmLanguageFileUpload } from '../../interfaces';

export const PRIZM_RUSSIAN_FILE_UPLOAD: PrizmLanguageFileUpload = {
  fileUpload: {
    dropzone__description: 'Выберите файл или перетащите его в эту область',
    dropzone__title: 'Загрузка файлов',
    btn__select: 'Выбрать',
    btn__select_hint_error: 'Достигнут максимум количества загруженных файлов',
    file_size__byte: 'Б',
    file_size__kb: 'Кбайт',
    file_size__mb: 'Мбайт',
    idle: 'Ожидание загрузки',
    progress: 'Загрузка',
    warning: 'Ошибка',
    success: 'Загружено',
  },
};
